import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { useLanguage } from '../../../../contexts/LanguageContext';

const MatnrIntegrationStatusFilters = ({
    filters,
    onApplyFilters,
    onReset
}) => {
    const { th } = useLanguage();
    const [filterOpen, setFilterOpen] = useState(true);

    const [localFilters, setLocalFilters] = useState({
        matnr: filters.matnr
    });

    useEffect(() => {
        setLocalFilters({
            matnr: filters.matnr
        });
    }, [filters.matnr]);

    const toggleOpen = () => setFilterOpen((prev) => !prev);

    const handleMatnrChange = (e) => {
        setLocalFilters(prev => ({ ...prev, matnr: e.target.value }));
    };

    const handleApply = () => {
        onApplyFilters(localFilters);
    };

    const handleReset = () => {
        onReset();
    };

    return (
        <div className="generic-table-filter">
            <div className="grid">
                <div className="col-12 md:col-6 flex justify-content-start">
                    <Button
                        icon="pi pi-filter"
                        label={th('common.filter')}
                        onClick={toggleOpen}
                        outlined={!filterOpen}
                    />
                </div>
            </div>

            {filterOpen && (
                <div className="mt-3">
                    <Divider />
                    <div className="text-xl font-medium mb-3">
                        {th('filter.advancedFilters')}
                    </div>

                    <div className="flex flex-wrap gap-2" style={{ alignItems: 'end' }}>
                        <div className="flex-auto" style={{ minWidth: 200, maxWidth: 280 }}>
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">
                                    {th('matnrIntegrationStatus.filter.matnr') || 'Parça Kodu'}
                                </label>
                                <InputText
                                    id="matnr"
                                    value={localFilters.matnr || ''}
                                    onChange={handleMatnrChange}
                                    className="w-full"
                                    placeholder={th('matnrIntegrationStatus.filter.matnrPlaceholder') || 'Parça kodu giriniz'}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-content-start mt-3 gap-2">
                        <Button
                            label={th('filter.reset')}
                            icon="pi pi-refresh"
                            className="p-button-outlined"
                            onClick={handleReset}
                        />
                        <Button
                            label={th('filter.apply')}
                            icon="pi pi-search"
                            onClick={handleApply}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default MatnrIntegrationStatusFilters;